import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";

export const getPatients = createAsyncThunk('/getPatients', async (_, { rejectWithValue }) => {

    try {
        const response = await axios.get(ENDPOINTS.PATIENT.PATIENT_LIST)
        return response.data;
    } catch (error) {
        return rejectWithValue(
            error.response?.data ||
            "Something went wrong while fetching the buyer profile."
        );
    }
})

const initialState = {
    data: [],
    isLoading: true,
    error: null,
};

const getPatientsSlice = createSlice(
    {
        name: "clinic",
        initialState,
        extraReducers: (builder) => {
            builder.addCase(getPatients.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.isLoading = false;
                state.error = null;
            })
                .addCase(getPatients.pending, (state) => {
                    state.isLoading = true;
                    state.error = null;
                })
                .addCase(getPatients.rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.payload;
                })
        }
    }
)

export default getPatientsSlice.reducer;